<script>
    import TotalAmountsBase from "@/components/base_components/TotalAmountsBase.vue";
    import TripService from "@/store/services/trip.service";

    export default {
        name: "TotalAmountTrip",
        extends: TotalAmountsBase,
        methods:{
            getTotalAmounts(){
                let vm = this;

                TripService.getTotals(this.filters).then(function(response) {
                    let distanceText = response.data.total_business.toFixed(1);

                    vm.amountsList = [];
                    vm.amountsList.push({text: vm.$gettext("TIME"), amount: vm.calculate_hours(response.data.total_hours), class:'green'});
                    vm.amountsList.push({text: vm.$gettext("TOTAL"), amount: distanceText + " KM", class:'green'});
                });
            },
            calculate_hours(total_hours) {
                let floatDuration = parseFloat(total_hours);
                let hourDetail = parseInt(floatDuration);
                let minuteDetail = ((floatDuration - hourDetail) * 60).toFixed();
                return hourDetail + this.$gettext("h") + " " + minuteDetail + this.$gettext("m");
            }
        }
    }
</script>
